import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const SkypeHatchedIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      // cacheName="hatched/skype"
      ref={ref as any}
      {...props}
    >
      <mask height="20" id="mask0_103_82" maskUnits="userSpaceOnUse" style={{ 'maskType': 'alpha' }} width="21" x="3" y="4">
        <g clipPath="url(#clip0_103_82)">
          <path
            d="M3.9994 23.4897C5.44126 18.8029 6.85211 16.0496 7.92188 14.3636C8.29397 13.7913 8.89862 12.8787 9.67382 11.4247C10.6506 9.59947 10.8676 8.79514 11.7978 7.09367C12.2165 6.32028 12.8211 5.28393 13.6583 4.10837"
            fill="#FFCEC3"
          />
          <path
            d="M3.9994 23.4897C5.44126 18.8029 6.85211 16.0496 7.92188 14.3636C8.29397 13.7913 8.89862 12.8787 9.67382 11.4247C10.6506 9.59947 10.8676 8.79514 11.7978 7.09367C12.2165 6.32028 12.8211 5.28393 13.6583 4.10837"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.9994 19.2669C4.54203 18.2924 4.96064 17.4572 5.28622 16.792C5.58079 16.1733 6.03041 15.2453 6.52653 14.0078C7.02265 12.7704 7.03816 12.5384 7.45676 11.6876C7.90637 10.7596 7.9994 10.8214 8.43351 9.93977C8.99165 8.79514 8.85211 8.68687 9.47227 7.35663C9.96839 6.27387 10.4335 5.56235 10.604 5.2994C10.9296 4.80442 11.2397 4.40226 11.4878 4.10837"
            fill="#FFCEC3"
          />
          <path
            d="M3.9994 19.2669C4.54203 18.2924 4.96064 17.4572 5.28622 16.792C5.58079 16.1733 6.03041 15.2453 6.52653 14.0078C7.02265 12.7704 7.03816 12.5384 7.45676 11.6876C7.90637 10.7596 7.9994 10.8214 8.43351 9.93977C8.99165 8.79514 8.85211 8.68687 9.47227 7.35663C9.96839 6.27387 10.4335 5.56235 10.604 5.2994C10.9296 4.80442 11.2397 4.40226 11.4878 4.10837"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.9994 16.0187C4.15444 15.5391 4.43351 14.7503 4.83661 13.8222C5.25521 12.8787 5.39475 12.7085 6.07692 11.2391C6.55754 10.2027 6.55754 10.1408 7.11568 8.96529C7.5963 7.94441 7.70482 7.75879 8.0149 7.10914C8.34048 6.42855 8.79009 5.40767 9.25521 4.10837"
            fill="#FFCEC3"
          />
          <path
            d="M3.9994 16.0187C4.15444 15.5391 4.43351 14.7503 4.83661 13.8222C5.25521 12.8787 5.39475 12.7085 6.07692 11.2391C6.55754 10.2027 6.55754 10.1408 7.11568 8.96529C7.5963 7.94441 7.70482 7.75879 8.0149 7.10914C8.34048 6.42855 8.79009 5.40767 9.25521 4.10837"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.9994 11.9659C4.48002 10.8058 4.92963 9.87769 5.25521 9.25897C5.79785 8.19168 6.07692 7.74312 6.60405 6.72223C7.14668 5.62401 7.53428 4.71141 7.78234 4.12363"
            fill="#FFCEC3"
          />
          <path
            d="M3.9994 11.9659C4.48002 10.8058 4.92963 9.87769 5.25521 9.25897C5.79785 8.19168 6.07692 7.74312 6.60405 6.72223C7.14668 5.62401 7.53428 4.71141 7.78234 4.12363"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.9994 8.67119C4.21645 8.22262 4.43351 7.77405 4.63506 7.29455C4.97614 6.52115 5.08467 6.18086 5.39475 5.51574C5.54978 5.15998 5.78234 4.68047 6.07692 4.12363"
            fill="#FFCEC3"
          />
          <path
            d="M3.9994 8.67119C4.21645 8.22262 4.43351 7.77405 4.63506 7.29455C4.97614 6.52115 5.08467 6.18086 5.39475 5.51574C5.54978 5.15998 5.78234 4.68047 6.07692 4.12363"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.9994 5.37653C4.10792 5.23732 4.26296 5.03623 4.38699 4.78875C4.51103 4.52579 4.58854 4.29377 4.63506 4.12363"
            fill="#FFCEC3"
          />
          <path
            d="M3.9994 5.37653C4.10792 5.23732 4.26296 5.03623 4.38699 4.78875C4.51103 4.52579 4.58854 4.29377 4.63506 4.12363"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M5.17769 23.799C5.39474 23.4432 5.73583 22.8864 6.07691 22.1594C6.69707 20.8601 6.79009 20.195 7.34823 18.7874C7.84435 17.5345 8.32497 16.6219 8.58854 16.1424C9.42575 14.5801 9.67381 14.5337 10.6506 12.8168C11.4102 11.4866 11.2552 11.533 12.1699 9.89336C13.0226 8.34657 13.2862 8.08362 13.8599 6.96993C14.4645 5.7789 14.8521 4.74255 15.0692 4.10837"
            fill="#FFCEC3"
          />
          <path
            d="M5.17769 23.799C5.39474 23.4432 5.73583 22.8864 6.07691 22.1594C6.69707 20.8601 6.79009 20.195 7.34823 18.7874C7.84435 17.5345 8.32497 16.6219 8.58854 16.1424C9.42575 14.5801 9.67381 14.5337 10.6506 12.8168C11.4102 11.4866 11.2552 11.533 12.1699 9.89336C13.0226 8.34657 13.2862 8.08362 13.8599 6.96993C14.4645 5.7789 14.8521 4.74255 15.0692 4.10837"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M6.69707 23.799C7.05366 23.3659 7.56529 22.7008 8.10793 21.8191C9.08467 20.2259 9.1932 19.4525 10.3405 16.8385C11.0072 15.3226 11.3947 14.4564 12.0614 13.2963C12.8676 11.9042 13.0847 11.8423 14.232 9.9243C14.7901 9.01169 15.3482 8.06815 15.9529 6.76885C16.449 5.70156 16.7901 4.78896 17.0227 4.10837"
            fill="#FFCEC3"
          />
          <path
            d="M6.69707 23.799C7.05366 23.3659 7.56529 22.7008 8.10793 21.8191C9.08467 20.2259 9.1932 19.4525 10.3405 16.8385C11.0072 15.3226 11.3947 14.4564 12.0614 13.2963C12.8676 11.9042 13.0847 11.8423 14.232 9.9243C14.7901 9.01169 15.3482 8.06815 15.9529 6.76885C16.449 5.70156 16.7901 4.78896 17.0227 4.10837"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M8.96064 23.799C9.22421 23.2267 9.56529 22.4688 9.9994 21.5871C11.0072 19.4525 11.7978 17.8748 11.9994 17.5036C12.418 16.6838 13.1467 15.2453 14.0924 13.4819C15.1622 11.502 15.3482 11.27 16.1234 9.73869C16.6816 8.64047 17.1467 7.68146 17.5343 6.8926C18.0614 5.79437 18.511 4.85083 18.8366 4.12384"
            fill="#FFCEC3"
          />
          <path
            d="M8.96064 23.799C9.22421 23.2267 9.56529 22.4688 9.9994 21.5871C11.0072 19.4525 11.7978 17.8748 11.9994 17.5036C12.418 16.6838 13.1467 15.2453 14.0924 13.4819C15.1622 11.502 15.3482 11.27 16.1234 9.73869C16.6816 8.64047 17.1467 7.68146 17.5343 6.8926C18.0614 5.79437 18.511 4.85083 18.8366 4.12384"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M23.7668 4.49506C22.325 9.18183 20.9141 11.9351 19.8444 13.6211C19.4723 14.1934 18.8676 15.106 18.0924 16.56C17.1157 18.3852 16.8986 19.1896 15.9684 20.891C15.5498 21.6644 14.9451 22.7008 14.1079 23.8763"
            fill="#FFCEC3"
          />
          <path
            d="M23.7668 4.49506C22.325 9.18183 20.9141 11.9351 19.8444 13.6211C19.4723 14.1934 18.8676 15.106 18.0924 16.56C17.1157 18.3852 16.8986 19.1896 15.9684 20.891C15.5498 21.6644 14.9451 22.7008 14.1079 23.8763"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M23.7668 8.73315C23.2242 9.70763 22.7901 10.5429 22.48 11.208C22.1854 11.8267 21.7358 12.7548 21.2397 13.9922C20.7436 15.2297 20.7281 15.4617 20.3095 16.3124C19.8599 17.2405 19.7668 17.1786 19.3327 18.0603C18.7591 19.1895 18.8986 19.3132 18.294 20.628C17.7978 21.7107 17.3327 22.4222 17.1622 22.6852C16.8366 23.1802 16.5265 23.5823 16.2785 23.8762"
            fill="#FFCEC3"
          />
          <path
            d="M23.7668 8.73315C23.2242 9.70763 22.7901 10.5429 22.48 11.208C22.1854 11.8267 21.7358 12.7548 21.2397 13.9922C20.7436 15.2297 20.7281 15.4617 20.3095 16.3124C19.8599 17.2405 19.7668 17.1786 19.3327 18.0603C18.7591 19.1895 18.8986 19.3132 18.294 20.628C17.7978 21.7107 17.3327 22.4222 17.1622 22.6852C16.8366 23.1802 16.5265 23.5823 16.2785 23.8762"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M23.7668 11.9814C23.6118 12.461 23.3327 13.2498 22.9296 14.1779C22.511 15.1214 22.3715 15.2916 21.6893 16.761C21.2087 17.7974 21.2087 17.8592 20.6506 19.0348C20.1699 20.0557 20.0614 20.2413 19.7513 20.891C19.4258 21.5715 18.9761 22.5924 18.511 23.8917"
            fill="#FFCEC3"
          />
          <path
            d="M23.7668 11.9814C23.6118 12.461 23.3327 13.2498 22.9296 14.1779C22.511 15.1214 22.3715 15.2916 21.6893 16.761C21.2087 17.7974 21.2087 17.8592 20.6506 19.0348C20.1699 20.0557 20.0614 20.2413 19.7513 20.891C19.4258 21.5715 18.9761 22.5924 18.511 23.8917"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M23.7668 16.034C23.2707 17.1941 22.8211 18.1222 22.511 18.7409C21.9684 19.8082 21.6893 20.2568 21.1622 21.2776C20.6196 22.3759 20.232 23.2885 19.9839 23.8763"
            fill="#FFCEC3"
          />
          <path
            d="M23.7668 16.034C23.2707 17.1941 22.8211 18.1222 22.511 18.7409C21.9684 19.8082 21.6893 20.2568 21.1622 21.2776C20.6196 22.3759 20.232 23.2885 19.9839 23.8763"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M23.7668 19.3288C23.5498 19.7774 23.3327 20.226 23.1312 20.7055C22.7901 21.4789 22.6816 21.8192 22.3715 22.4843C22.2164 22.84 21.9839 23.3195 21.6893 23.8764"
            fill="#FFCEC3"
          />
          <path
            d="M23.7668 19.3288C23.5498 19.7774 23.3327 20.226 23.1312 20.7055C22.7901 21.4789 22.6816 21.8192 22.3715 22.4843C22.2164 22.84 21.9839 23.3195 21.6893 23.8764"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M23.7668 22.6235C23.6428 22.7627 23.5033 22.9483 23.3637 23.2113C23.2397 23.4742 23.1622 23.7062 23.1157 23.8764"
            fill="#FFCEC3"
          />
          <path
            d="M23.7668 22.6235C23.6428 22.7627 23.5033 22.9483 23.3637 23.2113C23.2397 23.4742 23.1622 23.7062 23.1157 23.8764"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M22.573 4.18579C22.356 4.54155 22.0149 5.0984 21.6738 5.80992C21.0537 7.10922 20.9606 7.77434 20.4025 9.18192C19.9064 10.4348 19.4258 11.3474 19.1622 11.8269C18.325 13.3892 18.0769 13.4356 17.1002 15.1525C16.3405 16.4828 16.4955 16.4364 15.5808 18.076C14.7281 19.6228 14.4645 19.8857 13.8909 20.9994C13.2862 22.1904 12.8986 23.2268 12.6816 23.861"
            fill="#FFCEC3"
          />
          <path
            d="M22.573 4.18579C22.356 4.54155 22.0149 5.0984 21.6738 5.80992C21.0537 7.10922 20.9606 7.77434 20.4025 9.18192C19.9064 10.4348 19.4258 11.3474 19.1622 11.8269C18.325 13.3892 18.0769 13.4356 17.1002 15.1525C16.3405 16.4828 16.4955 16.4364 15.5808 18.076C14.7281 19.6228 14.4645 19.8857 13.8909 20.9994C13.2862 22.1904 12.8986 23.2268 12.6816 23.861"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M21.0692 4.18579C20.7126 4.61889 20.2009 5.28401 19.6583 6.16568C18.6816 7.75888 18.573 8.53227 17.4258 11.1463C16.7591 12.6622 16.3715 13.5284 15.7048 14.6885C14.8986 16.0806 14.6816 16.1425 13.5343 18.0605C12.9761 18.9731 12.418 19.9166 11.8134 21.216C11.3172 22.2832 10.9761 23.1958 10.7436 23.8764"
            fill="#FFCEC3"
          />
          <path
            d="M21.0692 4.18579C20.7126 4.61889 20.2009 5.28401 19.6583 6.16568C18.6816 7.75888 18.573 8.53227 17.4258 11.1463C16.7591 12.6622 16.3715 13.5284 15.7048 14.6885C14.8986 16.0806 14.6816 16.1425 13.5343 18.0605C12.9761 18.9731 12.418 19.9166 11.8134 21.216C11.3172 22.2832 10.9761 23.1958 10.7436 23.8764"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
      </mask>
      <g mask="url(#mask0_103_82)">
        <circle cx="13.6603" cy="14" fill="#FFCEC3" r="10" />
      </g>
      <path
        d="M11.3306 18.2147C10.8819 18.2918 10.4239 18.3309 9.96901 18.3309C5.52321 18.3309 1.90643 14.6793 1.90643 10.191C1.90643 9.68097 1.95303 9.1724 2.04502 8.67945C2.07531 8.51718 2.04858 8.34933 1.96953 8.20477C1.6013 7.53166 1.40664 6.76823 1.40664 5.99723C1.40654 3.47329 3.4405 1.42007 5.94058 1.42007C6.32897 1.42007 6.64385 1.10216 6.64385 0.710033C6.64385 0.317906 6.32897 0 5.94058 0C2.66493 0 0 2.69027 0 5.99713C0 6.92178 0.213701 7.8383 0.620004 8.66364C0.540206 9.16502 0.499885 9.67747 0.499885 10.1909C0.499885 15.4623 4.74774 19.7509 9.96901 19.7509C10.5027 19.7509 11.04 19.705 11.5664 19.6147C11.9493 19.5489 12.2069 19.1823 12.1418 18.7957C12.0767 18.4091 11.7137 18.149 11.3306 18.2147Z"
        fill="#FF7870"
      />
      <path
        d="M19.2905 11.8791C19.3885 11.3215 19.4381 10.7547 19.4381 10.1909C19.4381 4.91923 15.1904 0.630341 9.96921 0.630341C9.47757 0.630341 8.98275 0.668966 8.49853 0.745177C8.11473 0.805577 7.85217 1.16864 7.912 1.55613C7.97182 1.94362 8.33152 2.20879 8.71523 2.1483C9.12791 2.08335 9.54987 2.05041 9.96921 2.05041C14.4148 2.05041 18.0316 5.70225 18.0316 10.1909C18.0316 10.7367 17.977 11.286 17.8695 11.8235C17.8397 11.9722 17.8579 12.1267 17.9214 12.2642C18.202 12.8715 18.3441 13.5212 18.3441 14.1953C18.3441 16.719 16.3104 18.7723 13.8105 18.7723C13.4221 18.7723 13.1072 19.0902 13.1072 19.4823C13.1072 19.8744 13.4221 20.1923 13.8105 20.1923C17.0859 20.1923 19.7507 17.5021 19.7507 14.1953C19.7507 13.3912 19.596 12.6132 19.2905 11.8791Z"
        fill="#FF7870"
      />
      <path
        d="M13.5567 11.8045C13.5567 11.3807 13.4742 11.018 13.3118 10.7267C13.1495 10.4352 12.9203 10.1908 12.6301 9.99926C12.3396 9.80954 11.9829 9.645 11.5697 9.51199C11.1608 9.37936 10.6921 9.25543 10.1774 9.14344C9.76979 9.04848 9.47198 8.97502 9.294 8.92475C9.11528 8.87495 8.93777 8.80584 8.76589 8.71846C8.59251 8.6307 8.4543 8.52448 8.35453 8.40216C8.25438 8.27786 8.20543 8.13434 8.20543 7.96421C8.20543 7.68948 8.34881 7.46066 8.64418 7.26497C8.93496 7.0725 9.32326 6.97499 9.79811 6.97499C10.3175 6.97499 10.6839 7.06219 10.9186 7.24197C11.1499 7.42014 11.351 7.67035 11.5156 7.98703C11.6465 8.21414 11.762 8.36893 11.8713 8.46625C12.0068 8.58715 12.2067 8.61299 12.3505 8.61299C12.5806 8.61299 12.7752 8.53091 12.9289 8.3694C13.0828 8.20752 13.1606 8.02348 13.1606 7.82249C13.1606 7.60162 13.0979 7.37214 12.9743 7.14038C12.8513 6.9092 12.6528 6.68435 12.3847 6.47267C12.1168 6.26174 11.7756 6.09001 11.3701 5.9622C10.9639 5.83572 10.4762 5.77097 9.9202 5.77097C9.2234 5.77097 8.60911 5.86819 8.09479 6.06066C7.58037 6.25237 7.18128 6.53127 6.90926 6.88932C6.63742 7.24755 6.4993 7.66268 6.4993 8.12279C6.4993 8.60599 6.62992 9.01601 6.8875 9.34196C7.14518 9.66744 7.4986 9.92779 7.93772 10.1163C8.37881 10.3056 8.93187 10.4727 9.58113 10.613C10.0642 10.7149 10.4583 10.8135 10.7533 10.9061C11.0436 10.9971 11.2844 11.1314 11.4688 11.3053C11.6527 11.4795 11.7461 11.7091 11.7461 11.9874C11.7461 12.3442 11.5779 12.6328 11.2323 12.8714C10.8917 13.1056 10.4425 13.2244 9.89807 13.2244C9.50208 13.2244 9.17745 13.1654 8.93412 13.0491C8.69097 12.9329 8.49931 12.7828 8.36465 12.6032C8.23094 12.4245 8.10444 12.1986 7.98826 11.9303C7.89384 11.706 7.77784 11.5338 7.64413 11.4194C7.51041 11.3052 7.34444 11.2469 7.15062 11.2469C6.9086 11.2469 6.71487 11.3194 6.55884 11.468C6.4044 11.6141 6.32601 11.7924 6.32601 11.9982C6.32601 12.3525 6.45645 12.7218 6.71337 13.0965C6.97133 13.4718 7.31087 13.7757 7.7228 14.0002C8.30408 14.3113 9.05105 14.4688 9.94458 14.4688C10.6892 14.4688 11.3429 14.3533 11.8875 14.1251C12.4312 13.8968 12.8497 13.5768 13.1317 13.1739C13.4135 12.7711 13.5567 12.3105 13.5567 11.8045Z"
        fill="#FF7870"
      />
    </SvgIcon>
  );
});
